<template>
  <v-card>
    <v-layout>
      <TopBar />
      <LateralBar />
      <v-main style="background-color: #f5f8fa; min-height: 100vh">
        <slot></slot>
      </v-main>
    </v-layout>
  </v-card>
</template>

<script setup>
import TopBar from "@/ai_studio/components/layout/TopBar.vue"
import LateralBar from "@/ai_studio/components/layout/LateralBar.vue";
</script>
